var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 20,
    viewBox: "0 0 7 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.0625C4.01777 4.0625 4.4375 3.64277 4.4375 3.125C4.4375 2.60723 4.01777 2.1875 3.5 2.1875C2.98223 2.1875 2.5625 2.60723 2.5625 3.125C2.5625 3.64277 2.98223 4.0625 3.5 4.0625Z",
    stroke: "#1E232C",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.9375C4.01777 10.9375 4.4375 10.5178 4.4375 10C4.4375 9.48223 4.01777 9.0625 3.5 9.0625C2.98223 9.0625 2.5625 9.48223 2.5625 10C2.5625 10.5178 2.98223 10.9375 3.5 10.9375Z",
    stroke: "#1E232C",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.8125C4.01777 17.8125 4.4375 17.3928 4.4375 16.875C4.4375 16.3572 4.01777 15.9375 3.5 15.9375C2.98223 15.9375 2.5625 16.3572 2.5625 16.875C2.5625 17.3928 2.98223 17.8125 3.5 17.8125Z",
    stroke: "#1E232C",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c6dab48c33d7c1e8fb9e53728a281fdb.svg";
export { ForwardRef as ReactComponent };